import React from 'react';

import { Urls } from 'js/src/client';
import Button, { BUTTON_COLORS, BUTTON_SIZES } from 'js/src/components/common/ui/Button';
import Callout, { CALLOUT_TYPES } from 'js/src/components/common/ui/Callout';
import { trackUpsellClicked } from 'js/src/libs/analytics-utils';

export const UpgradeToRemoveWatermarkCallout = React.memo(
    function UpgradeToRemoveWatermarkCallout() {
        const onUpsellClicked = React.useCallback(() => {
            const context = 'remove_lumen5_watermark_prompt';
            trackUpsellClicked(context);
            window.open(Urls.PRICING, '_blank');
        }, []);

        return (
            <div className="upgrade-to-remove-watermark-callout">
                <Callout msgType={CALLOUT_TYPES.UPSELL}>
                    <div className="d-flex align-items-center">
                        <i className="material-symbols-outlined me-l5-16">workspace_premium</i>
                        <div>
                            <p className="mb-l5-0">
                                <strong>Upgrade your plan</strong> to remove the Lumen5 watermark
                            </p>
                        </div>
                        <Button
                            text="Upgrade"
                            color={BUTTON_COLORS.UPSELL}
                            className="ms-l5-auto flex-shrink-0"
                            onClick={onUpsellClicked}
                            size={BUTTON_SIZES.MD}
                        />
                    </div>
                </Callout>
            </div>
        );
    },
);
